import { useState } from '@wordpress/element';
import { Button, Grid } from 'semantic-ui-react';
import SortableTable from './Table';
import tableData from './data';
import './index.scss';
const App = () => {
    const [measure, setmeasure] = useState('heard');
    return (
        <Grid columns={2} stackable>
            <Grid.Column width={5} id="sidebar">
                <div className="topics tables">
                    <h4>Compare News Sources: How many ...?</h4>
                    <ul className="key measures">
                        <li>
                            <a
                                className={measure === 'heard' ? 'active' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setmeasure('heard');
                                }}
                            >
                                Have heard of
                            </a>
                        </li>
                        <li>
                            <a
                                className={
                                    measure === 'consume' ? 'active' : ''
                                }
                                onClick={(e) => {
                                    e.preventDefault();
                                    setmeasure('consume');
                                }}
                            >
                                Get news from
                            </a>
                        </li>
                        <li>
                            <a
                                className={measure === 'trust' ? 'active' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setmeasure('trust');
                                }}
                            >
                                Trust
                            </a>
                        </li>
                        <li>
                            <a
                                className={
                                    measure === 'distrust' ? 'active' : ''
                                }
                                onClick={(e) => {
                                    e.preventDefault();
                                    setmeasure('distrust');
                                }}
                            >
                                Distrust
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="topics">
                    <h4>Related Content</h4>
                    <ul className="key">
                        <li>
                            <a
                                href="https://www.journalism.org/2015/06/01/millennials-political-news/"
                                className="link"
                            >
                                Full Report: Millennials & Political News
                            </a>
                        </li>
                    </ul>
                </div>
            </Grid.Column>
            <Grid.Column width={10}>
                <p>
                    Where do Millennials, Gen Xers and Baby Boomers get their
                    news about politics and government? How do media habits
                    differ across these three generations? A{' '}
                    <a href="https://www.journalism.org/2015/06/01/millennials-political-news/">
                        Pew Research Center study
                    </a>{' '}
                    explores which sources they are familiar with, turn to,
                    trust and distrust.
                </p>
                <SortableTable
                    measure={measure}
                    tableData={tableData[measure]}
                />
                <p className="source">
                    <strong>Source:</strong> American Trends Panel (wave 1).
                    Survey conducted March 19-April 29, 2014. Based on online
                    adults. See{' '}
                    <a href="https://www.journalism.org/2015/06/01/methodology-60/">
                        Methodology
                    </a>{' '}
                    for sample sizes of each generation. Panelists were asked
                    about their awareness, use and trust of 36 news sources and
                    were also asked about use (but not awareness or trust) of
                    local television news and five social networking sites; see
                    the{' '}
                    <a href="https://www.journalism.org/interactives/generational-media-habits/consume/">
                        Get News From tab
                    </a>{' '}
                    to see the levels of usage for local television news and the
                    five social networking sites.) Due to the reliance on web
                    respondents, this report focuses on three generations –
                    Millennial, Generation X and Baby Boomer. The Silent
                    generation (aged 69 and older at the time of the survey) is
                    not included in the analysis because of the
                    disproportionately large segment that is not online.
                </p>
            </Grid.Column>
        </Grid>
    );
};

export default App;
